import { MapPin } from "lucide-react";
import { BRAZILIAN_STATES } from "@bookdental/schemas";
import { CartaoDados } from "./CartaoDados";
import { LinhaEditavel } from "./LinhaEditavel";
import { formatCep, mascara, soDigitos } from "./formatos";
import type { SecaoProps } from "./tipos";
import { useCamposDaFicha } from "./use-campos-da-ficha";

export function SecaoEndereco({ patient, salvar, somenteLeitura }: SecaoProps) {
  const { ver, obrigatorio } = useCamposDaFicha();
  if (!ver("endereco")) return null;
  // Endereço obrigatório: tudo menos o complemento.
  const comum = { somenteLeitura, obrigatorio: obrigatorio("endereco") };
  return (
    <CartaoDados icon={MapPin} titulo="Endereço" subtitulo="Localização do paciente" tom="verde">
      <LinhaEditavel
        {...comum}
        label="CEP"
        value={patient.zipCode ?? ""}
        formatDisplay={formatCep}
        maskInput={mascara(formatCep, 8)}
        normalize={soDigitos}
        inputMode="numeric"
        placeholder="00000-000 · busca automática"
        onSave={salvar.cep}
      />
      <LinhaEditavel {...comum} label="Logradouro" value={patient.address ?? ""} onSave={salvar.texto("address", "Logradouro")} />
      <LinhaEditavel {...comum} label="Número" value={patient.addressNumber ?? ""} inputMode="numeric" onSave={salvar.texto("addressNumber", "Número")} />
      <LinhaEditavel
        {...comum}
        obrigatorio={false}
        label="Complemento"
        value={patient.addressComplement ?? ""}
        placeholder="Apto, bloco, referência..."
        onSave={salvar.texto("addressComplement", "Complemento")}
      />
      <LinhaEditavel {...comum} label="Bairro" value={patient.neighborhood ?? ""} onSave={salvar.texto("neighborhood", "Bairro")} />
      <LinhaEditavel {...comum} label="Cidade" value={patient.city ?? ""} onSave={salvar.texto("city", "Cidade")} />
      <LinhaEditavel
        {...comum}
        label="UF"
        type="select"
        value={patient.state ?? ""}
        options={BRAZILIAN_STATES.map((s) => ({ value: s, label: s }))}
        onSave={salvar.opcao("state", "UF")}
      />
    </CartaoDados>
  );
}
